import React from 'react';
import PropTypes from 'prop-types';

const DEFAULT_IMG = 'https://assets.funliday.com/users/img_avatar_default.png';

const MemberImg = ({ alt, src, title, className, style, onClick }) => {
  // props.src 若有 user 圖片連結但 404 就要 fallback 回 DEFAULT_IMG) 不要相信使用者上傳的圖片是否有效
  const onMemberImgError = e => {
    e.target.onerror = null;
    e.target.src = DEFAULT_IMG;
  };

  return (
    <img
      src={src}
      alt={alt}
      title={title}
      className={className}
      style={style}
      onError={onMemberImgError}
      onClick={onClick}
    />
  );
};

MemberImg.defaultProps = {
  alt: 'member-img',
  title: 'member-title',
  src: DEFAULT_IMG,
  className: '',
  style: {},
  onClick: null,
};

MemberImg.propTypes = {
  alt: PropTypes.string,
  title: PropTypes.string,
  src: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func,
};

export default MemberImg;
